import axios from 'axios'
import role from '../../services/userRoles'
import router from '@/router'

export default {
  CHECK_INN({ commit, dispatch }, data) {
    commit('CHECK_INN_LOADING', true)
    return axios({
      method: 'POST',
      url: '/api/CustomerRegistration/EmployeeCheck',
      data
    })
      .then(response => {
        commit('CHECK_INN_SUCCESS', response.data)
      })
      .catch(error => {
        commit('CHECK_INN_ERROR', error.response.data.message)
        dispatch('NOTIFICATION', { open: true, color: 'error', text: error.response.data.message })
      })
  },
  GET_NAME({ commit, dispatch }, { inn, trigger }) {
    commit('SET_LOADING', { val: true, type: trigger })
    return axios({
      method: 'POST',
      url: '/api/CustomerRegistration/GetNameByInn',
      data: { inn }
    })
      .then(response => {
        trigger === 'organisation'
          ? commit('SET_ORGANISATION_NAME', response.data)
          : commit('SET_PERSONAL_NAME', response.data)
      })
      .catch(error => {
        commit('GET_NAME_ERROR', error.response.data.message)
        dispatch('NOTIFICATION', { open: true, color: 'error', text: error.response.data.message })
        commit('SET_LOADING', { val: false, type: trigger })
      })
  },
  CHECK_PIN_CODE({ commit, state, dispatch }, pin) {
    const payload = {
      innOrganisation: state.response.infoInn.innOrganisation,
      innEmployee: state.response.infoInn.innEmployee,
      pin
    }
    commit('CHECK_PIN_LOADING', true)
    axios({
      method: 'POST',
      url: '/api/CustomerRegistration/EmployeePinConfirm',
      data: payload
    })
      .then(response => {
        if (response.data.approve) {
          commit('CHECK_PIN_CODE_SUCCESS', response.data)
          commit('CHECK_PIN_LOADING', false)
          const result = role().setRole(response.data.role)
          if (result.error) {
            const e = Error()
            e.response = {
              data: {
                message: result.error
              }
            }
            throw e
          }
          router.push(role().getPath())
        } else {
          commit('CHECK_PIN_LOADING', false)
          dispatch('NOTIFICATION', { open: true, color: 'error', text: 'Вы ввели неправильный пинкод' })
        }
      })
      .catch(error => {
        const { data } = error.response
        commit('CHECK_PIN_CODE_ERROR', (data || {}).message)
        commit('CHECK_PIN_LOADING', false)
        dispatch('NOTIFICATION', {
          open: true,
          color: 'error',
          text: (data || {}).message || 'Неизвестная ошибка. Обратитесь к администретору.'
        })
      })
  }
}
